export enum RoleEnum {
  ROLE_ACCOUNTANT = 'ACCOUNTANT',
  ROLE_ADMIN = 'ADMIN',
  ROLE_USER = 'USER',
  ROLE_BRS = 'BRS',
  ROLE_TREASURER = 'TREASURER',
  ROLE_DIRECTOR = 'DIRECTOR',
  ROLE_1C_BOT = '1C_BOT',
  ROLE_BUGTRACKER_BOT = 'ROLE_BUGTRACKER_BOT',
  ROLE_MEGAPLAN_BOT = 'ROLE_MEGAPLAN_BOT',
  ROLE_AMOCRM_BOT = 'ROLE_AMOCRM_BOT',
  ROLE_HELPDESK_BOT = 'ROLE_HELPDESK_BOT',
}

